$(document).ready(function () {
    const contact_form = $('.contact-form-request-delivery');

    if(contact_form){
        let attr = contact_form.attr('action');
        let newAttr = attr + "?custom-delivery-form"
        contact_form.attr('action', newAttr);

        const wrapp = $('.close-request-delivery-popup');
        wrapp.addClass('success-form')
    }


    const quickview = $('.request-freight-quote--button');
    const quickviewPopup = $('#productModal-request');
    const quickviewPopupClose = $('.close-request-delivery-popup');
    const quickviewViewPopup = $('#productModal');
    const darkBg = $('.modal-backdrop');

    if (window.location.href.includes("?custom-delivery-form") && !window.location.href.includes("challenge?form_key=")) {
        contact_form.addClass('success-sent-form')
        const parent = contact_form.closest('#content')
        let bg = document.createElement('div');
        bg.className = "modal-backdrop fade in";
        document.body.append(bg)
        if(parent){
            parent.addClass('success-sent-form-parent');
        }
        if(quickviewPopup){
            quickviewPopup.css("display", "block");
            setTimeout(()=>{
                quickviewPopup.addClass("in");
                darkBg.addClass("in");
            }, 50)
        }
    }

    $('body').on('click', '.request-freight-quote--button', function (){
        const thisElement = $(this)
        let product;
        let domain = document.querySelector('body').getAttribute('data-domain')

        console.log(domain, "domain")
        if(thisElement) {
            product = {
                id: thisElement.data('id'),
                title: thisElement.data('title'),
                url: domain + thisElement.data('url')
            }

            console.log(product, "productJS FORM", window)
        }

        console.log(product, 'productsjdjhsjdjjdjdjdj')
        const inputTitle = $("#contactFormProductTitle")
        const inputUrl = $("#contactFormProductUrl")

        inputTitle.val(product.title)
        inputUrl.val(product.url)

        if(quickviewPopup){
            quickviewPopup.css("display", "block");
            setTimeout(()=>{
                quickviewPopup.addClass("in");
                darkBg.addClass("in");
            }, 50)
        }
        if(quickviewViewPopup){
            quickviewViewPopup.removeClass("in");
                setTimeout(()=>{
                    quickviewViewPopup.css("display", "none");
                }, 300)

        }
    });
    $('body').on('click', '.close-request-delivery-popup:not(.success-form)', function (){
        closeCustomDeliveryPopup(quickviewPopup, true)
    });
    $('body').on('click', '.close-request-delivery-popup.success-form', function (){
        closeCustomDeliveryPopup(quickviewPopup, false)
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState(null, "", newUrl);
        contact_form.removeClass('success-sent-form')
        const parent = contact_form.closest('#content')
        if(parent){
            parent.removeClass('success-sent-form-parent');
        }
        const darkBgr = $('.modal-backdrop');
        darkBgr.removeClass('in');
        darkBgr.removeClass('fade');
        darkBgr.removeClass('modal-backdrop');
    });

    let closeCustomDeliveryPopup = (target, closeProductPopup)=>{
        darkBg.removeClass("in");
        if(quickviewPopup && !closeProductPopup){
            quickviewPopup.removeClass("in");
            setTimeout(()=>{
                quickviewPopup.css("display", "none");
            }, 300)
        }
        if(closeProductPopup){
            if(quickviewViewPopup){
                quickviewViewPopup.css("display", "block");
                setTimeout(()=>{
                    quickviewViewPopup.addClass("in");
                }, 50)
            }
        }
        darkBg.cl
    }
});